export default {
  EQUIFAX_REGIONAL: 'equifax-regional',
  TRANSUNION_PERSONALIZED: 'transunion-personalized',
  USER_SUPPLIED: 'user-supplied',
};
